module.exports = __webpack_public_path__ + "img/python.79033d44.png";